import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _5gIcon(props: IconProps) {
    return <Icon {...props} iconKey={"5g"}/>
}
